import {useMutation, useQuery} from '@tanstack/react-query';
import {apiClient, queryClient} from '@common/http/query-client';
import {BackendResponse} from '@common/http/backend-response/backend-response';
import { showHttpErrorToast } from '@common/utils/http/show-http-error-toast';



const endpoint = (id: number|string) => `loan-applications/${id}/uw2-my-loan-download-md`;

interface Response extends BackendResponse {}

interface Payload {
  id: number|string;
}

export function useDownloadMdUwMyLoan() {
  return useMutation({
    mutationFn: (payload: Payload) => fetchMdUwMyLoan(payload),
    onError: err => showHttpErrorToast(err),
  });
}

function fetchMdUwMyLoan({id}: Payload): Promise<Response> {
  return apiClient.post(endpoint(id), {}, {responseType: 'blob'}).then(r => r.data);
}
